var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { StatusValue } from '../status';
var mockPromotionalOffersDescription = 'Client-defined text describing the plan - Promotional Control (PL RT PC) parameters of the Product Control File, Length 30.';
var mockCreatedDate = '2022-05-22T12:00:00-05:00';
export var mockDescription = 'AUTOMATIC PAYMENT - THANK YOU';
export var mockLocalTransactionId = '8a01b5f5-7115-47ad-bf0b-59157d89f70f';
var mockTransactionDate = '2022-05-22';
var mockStatementDate = [
    '2023-05-11',
    '2023-04-10',
    '2023-03-10',
    '2023-02-08',
    '2023-01-11',
    '2022-12-11',
    '2022-11-10',
    '2022-10-11'
];
var mockActivity = [
    {
        type: 'PAYMENT',
        localTransactionId: '00CHGDDA',
        paymentType: 'ONE_TIME_PAYMENT',
        status: StatusValue.PENDING,
        description: mockDescription,
        createdDate: mockCreatedDate,
        postedDate: '',
        amount: '-40.00',
        currencyCode: '',
        identifiers: [
            {
                id: 'F929400GY00CHGDDA000000000000000400020220522271',
                idType: 'PAYMENT_ID'
            },
            { id: '000000000000000', idType: 'AUTHORIZATION_ID' },
            { id: '', idType: 'PAYMENT_INSTRUMENT_REFERENCE_ID' }
        ],
        transactionInfo: {
            cardEntryMethod: '',
            promoCode: '',
            skuReferenceNumber: '00CHGDDA',
            skuReferenceDetails: [
                'Phone Tripod, UBeesize Portable',
                'Video Conference Lighting Kits',
                'SHIPPING AND TAX'
            ],
            transactionCode: '271',
            transactionId: '00CHGDDA',
            merchant: {
                categoryCode: '00000',
                description: mockDescription,
                name: '',
                city: '',
                state: '',
                zip: '',
                addressLine1: '',
                addressLine2: ''
            },
            recurringTransaction: false
        },
        paymentInfo: {}
    },
    {
        type: 'PAYMENT',
        localTransactionId: '00CHGDDA',
        paymentType: 'ONE_TIME_PAYMENT',
        status: StatusValue.PENDING,
        description: mockDescription,
        createdDate: mockCreatedDate,
        statementDate: mockTransactionDate,
        postedDate: '2022-05-22T12:00:00-05:00',
        amount: '-40.00',
        currencyCode: '',
        identifiers: [
            {
                id: 'F929400GY00CHGDDA000000000000000400020220522271',
                idType: 'PAYMENT_ID'
            },
            { id: '000000000000000', idType: 'AUTHORIZATION_ID' },
            { id: '', idType: 'PAYMENT_INSTRUMENT_REFERENCE_ID' }
        ],
        transactionInfo: {
            cardEntryMethod: '',
            promoCode: '',
            skuReferenceNumber: '00CHGDDA',
            skuReferenceDetails: [],
            transactionCode: '271',
            transactionId: '00CHGDDA',
            merchant: {
                categoryCode: '00000',
                description: mockDescription,
                name: '',
                city: '',
                state: '',
                zip: '',
                addressLine1: '',
                addressLine2: ''
            },
            recurringTransaction: false
        },
        paymentInfo: {}
    },
    {
        type: 'PAYMENT',
        localTransactionId: '00CHGDDA',
        paymentType: 'ONE_TIME_PAYMENT',
        status: StatusValue.PENDING,
        description: mockDescription,
        createdDate: mockCreatedDate,
        postedDate: '',
        amount: '-40.00',
        currencyCode: '',
        identifiers: [
            {
                id: 'F929400GY00CHGDDA000000000000000400020220522271',
                idType: 'PAYMENT_ID'
            },
            { id: '000000000000000', idType: 'AUTHORIZATION_ID' },
            { id: '', idType: 'PAYMENT_INSTRUMENT_REFERENCE_ID' }
        ],
        transactionInfo: {
            cardEntryMethod: '',
            promoCode: '',
            skuReferenceNumber: '00CHGDDA',
            skuReferenceDetails: [
                'Phone Tripod, UBeesize Portable',
                'Video Conference Lighting Kits',
                'SHIPPING AND TAX'
            ],
            transactionCode: '271',
            transactionId: '00CHGDDA',
            merchant: {
                categoryCode: '00000',
                description: mockDescription,
                name: '',
                city: '',
                state: '',
                zip: '',
                addressLine1: '',
                addressLine2: ''
            },
            recurringTransaction: false
        },
        paymentInfo: {
            scheduledDate: '2022-09-29T12:00:00-05:00',
            modifiedDate: '2022-09-12T12:00:00-05:00',
            id: '41798985',
            channel: 'ONLINE'
        }
    }
];
export var mockNormalizerData = {
    pageMetaData: {
        nextCursor: '100:123545'
    },
    activity: {
        items: (_a = {},
            _a[mockLocalTransactionId] = {
                type: 'REVERSAL',
                subType: 'ONE_TIME_PAYMENT',
                status: StatusValue.POSTED,
                description: 'REVERSAL',
                nonSufficientFundFee: true,
                createdDate: '2019-08-22T18:15:22Z',
                postedDate: '2019-08-22T18:15:23Z',
                amount: '107.17',
                currencyCode: '840',
                identifiers: [
                    {
                        id: '0',
                        idType: 'PAYMENT_ID'
                    }
                ],
                transactionInfo: {
                    transactionCode: '271',
                    cardEntryMethod: '91',
                    promoCode: '01',
                    skuReferenceNumber: 'B008A0GNA8',
                    transactionId: '123456789012345',
                    skuReferenceDetails: ['DOLLAR'],
                    merchant: {
                        categoryCode: '4821',
                        description: 'HOME DEPOT 2644 DANBURY',
                        name: 'HOME DEPOT',
                        city: 'DANBURY',
                        state: 'CT',
                        zip: '06810',
                        addressLine1: '99 Eagle Rd',
                        addressLine2: 'SUITE 99'
                    }
                },
                paymentInfo: {
                    scheduledDate: '2019-09-22T18:15:22Z',
                    modifiedDate: '2019-09-22T18:15:23Z',
                    id: 'c863003-4884-4c92-afcc-fefeb09bc2n4',
                    channel: 'ONLINE'
                },
                localTransactionId: mockLocalTransactionId
            },
            _a),
        itemsIds: [mockLocalTransactionId]
    }
};
export var mockActivityData = {
    pageMetaData: {
        nextCursor: ''
    },
    activity: mockActivity
};
export var mockTransactionDetails = {
    transactionId: '00CHGDDA',
    merchantName: mockDescription,
    referenceNumber: '',
    transactionCode: '271',
    transactionDate: mockTransactionDate,
    transactionAmount: '40.00',
    merchantDesc: mockDescription,
    statementDate: mockTransactionDate
};
export var mockInstallmentPromotion = {
    id: 'IL1.172A',
    termLength: '016',
    description: mockPromotionalOffersDescription,
    annualPercentageRate: '15.25',
    monthlyPaymentAmount: '71.35',
    estimatedInterestAmount: '43.14',
    estimatedTotalAmount: '114.11'
};
export var promoTermsPercentage = {
    '3': '34.1696',
    '6': '17.4029',
    '9': '11.8166',
    '12': '9.0254',
    '18': '6.2380',
    '24': '4.8482'
};
export var mockInstallmentTransactions = [
    {
        type: 'PURCHASE',
        status: 'POSTED',
        description: 'Amazon Seattle WA',
        createdDate: '2020-12-31T12:00:00-06:00',
        postedDate: '2020-12-31T12:00:00-06:00',
        statementDate: '2022-12-15',
        amount: '500.97',
        currencyCode: '840',
        transactionId: 'fe6ae5f6-6d1b-11ee-b962-0242ac120002',
        transactionOfferId: '4c725e64-c39f-4cb1-9d#b4-7b0669a$21144',
        transactionInfo: {
            transactionCode: '271',
            cardEntryMethod: '91',
            promoCode: 'X014j',
            skuReferenceNumber: 'B008A0GNA8',
            recurringTransaction: true,
            skuReferenceDetails: ['Amazon Seattle USA', 'RESTAURANT USA'],
            merchant: {
                categoryCode: '4821',
                description: 'LOWES 2544 DANBURY',
                name: 'AMAZON',
                city: 'SEATTLE',
                state: 'CT',
                zip: '06810',
                addressLine1: '64 Eagle Rd',
                addressLine2: ''
            }
        },
        promotionalOffers: [
            {
                id: 'IL1.172A',
                termLength: '018',
                description: mockPromotionalOffersDescription,
                annualPercentageRate: '15.25',
                monthlyPaymentAmount: '71.35',
                estimatedInterestAmount: '43.14',
                estimatedTotalAmount: '114.11'
            },
            {
                id: 'IL1.172B',
                termLength: '006',
                description: mockPromotionalOffersDescription,
                annualPercentageRate: '10.00',
                monthlyPaymentAmount: '100.35',
                estimatedInterestAmount: '73.14',
                estimatedTotalAmount: '250.11'
            },
            {
                id: 'IL1.122A',
                termLength: '003',
                description: mockPromotionalOffersDescription,
                annualPercentageRate: '5.00',
                monthlyPaymentAmount: '150.35',
                estimatedInterestAmount: '3.14',
                estimatedTotalAmount: '314.11'
            }
        ],
        localTransactionId: 'fe6ae5f6-6d1b-11ee-b962-0242ac120002'
    },
    {
        type: 'PURCHASE',
        status: 'PENDING',
        description: 'Hardware Store USA',
        createdDate: '2020-01-15T12:00:00-06:00',
        postedDate: '2020-01-15T12:00:00-06:00',
        statementDate: '2022-02-21',
        amount: '300.50',
        currencyCode: '840',
        transactionId: '4a36d1de-6d1c-11ee-b962-0242ac120002',
        transactionOfferId: '4c675e64-c39f-4cb1-9d#b4-7b0669a$21144',
        transactionInfo: {
            transactionCode: '161',
            cardEntryMethod: '29',
            promoCode: 'X014j',
            skuReferenceNumber: 'B008A0GNA8',
            recurringTransaction: true,
            skuReferenceDetails: ['Hardware Store USA', 'STORE USA'],
            merchant: {
                categoryCode: '4821',
                description: 'LOWES 2544 DANBURY',
                name: 'LOWES',
                city: 'DANBURY',
                state: 'CT',
                zip: '06810',
                addressLine1: '67 Eagle Rd',
                addressLine2: 'SUITE 1200'
            }
        },
        promotionalOffers: [
            {
                id: 'IL1.192A',
                termLength: '009',
                description: mockPromotionalOffersDescription,
                annualPercentageRate: '5.25',
                monthlyPaymentAmount: '80.35',
                estimatedInterestAmount: '47.14',
                estimatedTotalAmount: '40.11'
            },
            {
                id: 'IL2.172B',
                termLength: '018',
                description: mockPromotionalOffersDescription,
                annualPercentageRate: '2.00',
                monthlyPaymentAmount: '120.35',
                estimatedInterestAmount: '73.14',
                estimatedTotalAmount: '20.11'
            }
        ],
        localTransactionId: '4a36d1de-6d1c-11ee-b962-0242ac120002'
    }
];
export var mockStatementData = [
    {
        statementDate: mockStatementDate[0],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2023-04-11',
            statementEndDate: mockStatementDate[0],
            statementAmount: '3684.01'
        }
    },
    {
        statementDate: mockStatementDate[1],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2023-03-11',
            statementEndDate: mockStatementDate[1],
            statementAmount: '3571.58'
        }
    },
    {
        statementDate: mockStatementDate[2],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2023-02-09',
            statementEndDate: mockStatementDate[2],
            statementAmount: '3454.56'
        }
    },
    {
        statementDate: mockStatementDate[3],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2023-01-12',
            statementEndDate: mockStatementDate[3],
            statementAmount: '3338.04'
        }
    },
    {
        statementDate: mockStatementDate[4],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2022-12-12',
            statementEndDate: mockStatementDate[4],
            statementAmount: '3229.39'
        }
    },
    {
        statementDate: mockStatementDate[5],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2022-11-11',
            statementEndDate: mockStatementDate[5],
            statementAmount: '3115.92'
        }
    },
    {
        statementDate: mockStatementDate[6],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2022-10-12',
            statementEndDate: mockStatementDate[6],
            statementAmount: '3005.30'
        }
    },
    {
        statementDate: mockStatementDate[7],
        statementDetails: {
            statementInsert: '',
            statementStartDate: '2022-10-07',
            statementEndDate: mockStatementDate[7],
            statementAmount: '3007.50'
        }
    }
];
var mockSelectPayMutationError = {
    code: 'app.businessError',
    message: 'Business Validation Failure',
    trackingId: 'd6fe1ff7-bf8d-474a-99a4-3e83848e75dd',
    transient: false
};
export var mockSelectPayMutationErrorGeneric = __assign(__assign({}, mockSelectPayMutationError), { businessErrors: [
        {
            code: '600000',
            message: 'Generic message'
        }
    ] });
export var mockSelectPayMutationErrorLimit = __assign(__assign({}, mockSelectPayMutationError), { businessErrors: [
        {
            code: '600014',
            message: 'Transaction(s) not enrolled in to Post transaction installment as customer already have 4 transactions.'
        }
    ] });
export var mockSelectPayMutationErrorDisputes = __assign(__assign({}, mockSelectPayMutationError), { businessErrors: [
        {
            code: '600015',
            message: 'Transaction(s) not enrolled in to Post transaction as the transaction is currently in dispute.'
        }
    ] });
export var mockDrawerProps = {
    title: "Sam's Club® Credit Card",
    subtitle: 'Account ending in 1234',
    img: 'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img056431.png',
    fallbackImage: 'https://images.synchronycredit.com/assets/cardArt/syf_generic_card.svg',
    alt: 'Product card image'
};
export default mockActivity;
//# sourceMappingURL=activity-mock-data.js.map